import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    maxWidth: 396,
    margin: '5px auto',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(0, 1),
  },
  cardInput: {
    background: 'none',
    '&.Mui-error': {
      border: '1px solid #FF0000',
    },
    '&.MuiTextField-root fieldset': {
      border: 'none',
    },
    '&.MuiTextField-root .MuiInputBase-input': {
      background: 'none',
    }
  },
  cardForm: {
    margin: theme.spacing(0, 0, 1)
  },
  cardText: {
    color: theme.palette.grey.dark,
    fontSize: '12px',
    margin: theme.spacing(0, 0, .5),
    fontWeight: 600
  },
}));

export default useStyles;
